var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumbering3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2134 17.156C12.2774 17.156 11.3654 16.928 10.8254 16.628L11.1254 15.932C11.5694 16.148 12.2174 16.34 12.8774 16.34C13.9814 16.34 14.5814 15.884 14.5814 14.828C14.5814 13.7 13.8374 13.316 12.2774 13.304H11.9174V12.668H12.2774C13.7294 12.668 14.3534 12.152 14.3534 11.12C14.3534 10.268 13.8854 9.86 12.8894 9.86C12.4094 9.86 11.8454 10.004 11.4854 10.184L11.2214 9.512C11.7374 9.236 12.5294 9.044 13.3334 9.044C14.9894 9.044 15.7454 9.716 15.7454 10.952C15.7454 12.152 14.8934 12.788 13.7654 12.92C15.0614 13.016 15.9734 13.556 15.9734 14.864C15.9734 16.34 15.0854 17.156 13.2134 17.156Z",
    fill: "#080D1A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#BABABA",
    strokeDasharray: "3 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumbering3);
export default __webpack_public_path__ + "static/media/Numbering3.187981bd6ac6305479ad76bbd15c0e1f.svg";
export { ForwardRef as ReactComponent };